import { takeLatest } from 'redux-saga/effects'
import { SAVE_WHITELABEL } from 'app/redux-base/actions/configurator'
import saveWL from './saveWL'

export default function* watchSaveWL() {
  yield takeLatest(SAVE_WHITELABEL.REQUEST, saveWL)
}
